export default {
  tiny: 10,
  small: 12,
  regular: 14,
  large: 17,
  xlarge: 20,
};
